export default "__VITE_ASSET__0a1471dc__"